export default () => {
    const btnOpen = document.getElementsByClassName('btn-open');

    const createModal = () => {
        const youtubeURL = [
            'https://www.youtube.com/embed/xE71ZfK2fkE',
        ];

        let wrapperEl = document.createElement('div');
        let cotentEl = document.createElement('div');
        let youtubeEl = document.createElement('div');
        let contentWrapperEl = document.createElement('div');
        let btnEl = document.createElement('button');
        wrapperEl.id = 'modal-wrapper';
        cotentEl.className = 'content';
        youtubeEl.className = 'youtube';
        btnEl.className = 'close-btn';

        youtubeEl.innerHTML = `<iframe src=${youtubeURL[0]}?autoplay=1 frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        btnEl.innerHTML = '<img src="./img/btn_close.svg">';

        youtubeEl.appendChild(btnEl);
        cotentEl.appendChild(youtubeEl);
        contentWrapperEl.appendChild(cotentEl);
        wrapperEl.appendChild(contentWrapperEl);

        document.getElementsByTagName('body')[0].appendChild(wrapperEl);

        document.getElementById('modal-wrapper').querySelector('button').addEventListener('click', () => {
            document.getElementsByTagName('body')[0].removeChild(document.getElementById('modal-wrapper'));
        });
    };
    [].forEach.call(btnOpen, el => {
        el.addEventListener('click', createModal);
    })
}
